import React from "react";
import {
  Footer,
  Header,
  SectionBanner,
  SubtitleContainer,
  TitleContainer,
} from "../../components";
import "./index.scss";

const Complaints: React.FC = () => {
  const handleContactButtonClick = (url: string) => {
    window.open(url);
  };

  return (
    <div>
      <Header active="Canal de Denúncias" />
      <SectionBanner>Serviço de Atendimento</SectionBanner>
      <TitleContainer>Registrar uma Denúncia</TitleContainer>
      <SubtitleContainer>
        Valorizamos 100% seu Feedback. Clique no botão abaixo para acessar o
        formulário e registrar uma denúncia. Retornaremos o quanto antes a fim
        de resolver o problema!
      </SubtitleContainer>
      <div style={{ margin: "0 auto", width: "fit-content" }}>
        <button
          onClick={() => handleContactButtonClick('https://forms.gle/rVWt9iAMpNQFJXZP7')}
          className="center"
          style={{ margin: "5px 10px 30px", display: "inline-block" }}>
          Acessar Formulário - Pernambuco
        </button>
        <button
          onClick={() => handleContactButtonClick('https://forms.gle/ikNb4zcF7LBwxBeVA')}
          className="center"
          style={{ margin: "5px 10px 30px", display: "inline-block" }}>
          Acessar Formulário - Rio Grande do Norte
        </button>
      </div>
      <Footer />
    </div>
  );
};

export default Complaints;
